module.exports = __webpack_public_path__ + "img/7_cover1.735c7231.png";